export const defaultDigitalData = {
    page: {
        pageName: '',
        siteSection: '',
        hierarchy: '',
        userLanguage: '',
        client: 'fpro-us',
        country: 'fpro-us',
        site: 'pro.ford.com',
        pageNameNoVehicle: '',
        tool: '',
        toolDescriptor: '',
        radUIVersion: '',
    },
    vehicle: {
        modelYear: '',
        nameplate: '',
    },
    onclick: {
        onclick: '',
        onclickLinkName: '',
        referredTo: '',
    },
    event: {
        action: '',
    },
    user: {
        paCode: '',
        fordRegion: '',
        fdafCode: '',
        leadType: '',
        leadOptIn: '',
        loginStatus: '',
        optInStatus: '',
    },
};
